var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg800N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 39,
    viewBox: "0 0 55 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7694B4",
    d: "M20.8 29.3L22.2 32.2 25.4 32.7 23.2 35 23.8 38.2 20.9 36.7 18 38.2 18.6 35 16.3 32.7 19.5 32.2 20.8 29.3zM44.5 1.7L45.4 3.5 47.4 3.8 46 5.2 46.3 7.2 44.5 6.3 42.7 7.2 43 5.2 41.6 3.8 43.6 3.5 44.5 1.7zM7.5 15.7L8.4 17.5 10.4 17.8 9 19.2 9.3 21.2 7.5 20.3 5.7 21.2 6 19.2 4.6 17.8 6.6 17.5 7.5 15.7zM48.6 29.7L49.1 30.8 50.3 31 49.4 31.9 49.6 33.1 48.5 32.5 47.5 33 47.7 31.8 46.8 30.9 48 30.7 48.6 29.7zM29 14.6C25.6 9.8 25.6 4.1 28.3 0 23.2 1.8 19.5 6.7 19.5 12.5 19.5 19.8 25.4 25.8 32.8 25.8 37.4 25.8 41.4 23.5 43.8 20 38.4 21.7 32.4 19.4 29 14.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg800N);
export default __webpack_public_path__ + "static/media/800n.99cdbbd125fbc72118dd35fb9c7d5ecf.svg";
export { ForwardRef as ReactComponent };